import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n } from "react/jsx-runtime";
var r = {
	12: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 12 12",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.99985 0.712494C8.92 0.712494 11.2871 3.07971 11.2872 5.99985C11.2872 8.92005 8.92005 11.2872 5.99985 11.2872C3.07971 11.2871 0.712494 8.92 0.712494 5.99985C0.712573 3.07976 3.07976 0.712573 5.99985 0.712494ZM7.97299 4.02744C7.75335 3.80779 7.39726 3.80784 7.17758 4.02744L5.99985 5.20444L4.82285 4.02744C4.60318 3.80777 4.24711 3.80777 4.02744 4.02744C3.80777 4.24711 3.80777 4.60318 4.02744 4.82285L5.20444 5.99985L4.02744 7.17758C3.80784 7.39726 3.80779 7.75335 4.02744 7.97299C4.2471 8.19238 4.60326 8.1925 4.82285 7.97299L5.99985 6.79526L7.17758 7.97299C7.39728 8.19233 7.75343 8.19255 7.97299 7.97299C8.19255 7.75343 8.19233 7.39728 7.97299 7.17758L6.79526 5.99985L7.97299 4.82285C8.1925 4.60326 8.19238 4.2471 7.97299 4.02744Z",
				fill: "#8F8B85"
			})
		}),
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.99982 0.950012C11.8934 0.950012 15.0495 4.1063 15.0496 7.99982C15.0496 11.8934 11.8934 15.0496 7.99982 15.0496C4.1063 15.0495 0.950012 11.8934 0.950012 7.99982C0.950118 4.10636 4.10636 0.950118 7.99982 0.950012ZM10.6307 5.36993C10.3378 5.07707 9.86303 5.07714 9.57013 5.36993L7.99982 6.93927L6.43048 5.36993C6.13759 5.07704 5.66283 5.07704 5.36993 5.36993C5.07704 5.66283 5.07704 6.13759 5.36993 6.43048L6.93927 7.99982L5.36993 9.57013C5.07714 9.86303 5.07707 10.3378 5.36993 10.6307C5.66282 10.9232 6.1377 10.9234 6.43048 10.6307L7.99982 9.06036L9.57013 10.6307C9.86306 10.9231 10.3379 10.9234 10.6307 10.6307C10.9234 10.3379 10.9231 9.86306 10.6307 9.57013L9.06036 7.99982L10.6307 6.43048C10.9234 6.1377 10.9232 5.66282 10.6307 5.36993Z",
				fill: "#8F8B85"
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 20 20",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.99976 1.1875C14.8667 1.1875 18.8119 5.13286 18.812 9.99976C18.812 14.8668 14.8668 18.812 9.99976 18.812C5.13286 18.8119 1.1875 14.8667 1.1875 9.99976C1.18763 5.13294 5.13294 1.18763 9.99976 1.1875ZM13.2883 6.7124C12.9223 6.34633 12.3288 6.34641 11.9626 6.7124L9.99976 8.67407L8.03809 6.7124C7.67197 6.34629 7.07852 6.34629 6.7124 6.7124C6.34629 7.07852 6.34629 7.67197 6.7124 8.03809L8.67407 9.99976L6.7124 11.9626C6.34641 12.3288 6.34633 12.9223 6.7124 13.2883C7.07851 13.654 7.67211 13.6542 8.03809 13.2883L9.99976 11.3254L11.9626 13.2883C12.3288 13.6539 12.9224 13.6543 13.2883 13.2883C13.6543 12.9224 13.6539 12.3288 13.2883 11.9626L11.3254 9.99976L13.2883 8.03809C13.6542 7.67211 13.654 7.07851 13.2883 6.7124Z",
				fill: "#8F8B85"
			})
		}),
		width: 20,
		height: 20
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.9997 1.42499C17.84 1.42499 22.5742 6.15942 22.5744 11.9997C22.5744 17.8401 17.8401 22.5744 11.9997 22.5744C6.15942 22.5742 1.42499 17.84 1.42499 11.9997C1.42515 6.15952 6.15952 1.42515 11.9997 1.42499ZM15.946 8.05487C15.5067 7.61558 14.7945 7.61568 14.3552 8.05487L11.9997 10.4089L9.64569 8.05487C9.20635 7.61553 8.49421 7.61553 8.05487 8.05487C7.61553 8.49421 7.61553 9.20635 8.05487 9.64569L10.4089 11.9997L8.05487 14.3552C7.61568 14.7945 7.61558 15.5067 8.05487 15.946C8.4942 16.3848 9.20651 16.385 9.64569 15.946L11.9997 13.5905L14.3552 15.946C14.7946 16.3847 15.5069 16.3851 15.946 15.946C16.3851 15.5069 16.3847 14.7946 15.946 14.3552L13.5905 11.9997L15.946 9.64569C16.385 9.20651 16.3848 8.4942 15.946 8.05487Z",
				fill: "#8F8B85"
			})
		}),
		width: 24,
		height: 24
	}
}, i = ({ size: t = 16, ...i }) => /* @__PURE__ */ n(e, {
	source: r[t],
	...i
});
//#endregion
export { i as StatusCanceledIcon };
